document.addEventListener('DOMContentLoaded', () => {
  const marquees = document.querySelectorAll('.luxury-marquee');
  marquees.forEach((marquee) => {
    const group = marquee.querySelector('.luxury-marquee__group');
    if (!group) return;
    // Duplicate automatically if content isn't wide enough
    while (marquee.scrollWidth < window.innerWidth * 2) {
      marquee.appendChild(group.cloneNode(true));
    }
  });
});